import clsx from "clsx";

const LeaderboardLoading = ({
  rows = 25,
  columns = 4,
  loadingLayout = "default",
}: {
  rows?: number;
  columns?: number;
  loadingLayout: string;
}) => {
  return (
    <>
      {Array.from(Array(rows)).map((_item: any, i: number) => (
        <div
          role="tr"
          className="flex flex-col justify-between overflow-hidden opacity-100 transition-opacity duration-300"
          key={i}
        >
          <div
            role="tr"
            className="flex justify-between w-full gap-1.5 md:gap-2.5 py-0 px-2.5 lg:p-0"
          >
            {Array.from(Array(columns)).map((_item: any, n: number) => (
              <div
                role="td"
                className={clsx(
                  `relative flex items-center justify-center flex-1 py-[15px] px-0`,
                  {
                    "nth-of-type-3:flex-[5] nth-of-type-3:text-left nth-of-type-3:justify-start":
                      loadingLayout === "default",
                    "nth-of-type-3:flex-1 nth-of-type-5:flex-1 nth-of-type-4:flex-[5] nth-of-type-4:text-left nth-of-type-4:justify-start":
                      loadingLayout === "strokeplay",
                  }
                )}
                key={n}
              >
                <span className="inline-block h-[25px] bg-tm-c-dark opacity-30 w-[60%] rounded-[10px]" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default LeaderboardLoading;
